import numeral from 'numeral';
import { get, isEmpty, map, take } from 'lodash';

import { extractValue, maxScore } from './shared';

const MAX_AFFINITY_ACTOR_COUNT = 10;

export const formatMobilityScores = ({ data = [] } = {}) => {
  if (isEmpty(data)) {
    return null;
  }

  const mobilityData = get(data, 0, {});
  const max = maxScore(mobilityData);

  return [
    {
      label: 'Phone',
      value: `${extractValue(mobilityData, 'phonePercent')}%`,
      subValue: `${numeral(get(mobilityData, 'phoneVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.phonePercent === max
    },
    {
      label: 'Tablet',
      value: `${extractValue(mobilityData, 'tabletPercent')}%`,
      subValue: `${numeral(get(mobilityData, 'tabletVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.tabletPercent === max
    },
    {
      label: 'Computer',
      value: `${extractValue(mobilityData, 'computerPercent')}%`,
      subValue: `${numeral(get(mobilityData, 'computerVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.computerPercent === max
    },
    {
      label: 'TV',
      value: `${extractValue(mobilityData, 'tvPercent')}%`,
      subValue: `${numeral(get(mobilityData, 'tvVotes', '-')).format(
        '0,0'
      )} votes`,
      top: mobilityData.tvPercent === max
    }
  ];
};

export const formatFanVotesScore = ({ data = [] } = {}) => {
  const scoreData = get(data, 0, {});
  const score = Math.floor(get(scoreData, 'votes', 0));
  return [
    {
      value: numeral(score).format('0.0a'),
      label: 'Fan Favorite Votes',
      trend: 1
    }
  ];
};

export const formatActorsFromQuery = ({ data = [] } = {}) => {
  const formatActor = actor => ({
    id: actor.actorId,
    score: `${extractValue(actor, 'percentageOverlap')}`,
    name: actor.actorName,
    image: actor.actorImageUrl
  });

  return take(map(data, formatActor), MAX_AFFINITY_ACTOR_COUNT);
};
